export enum UseOptions {
  I = 'INTERNAL',
  E = 'DONATION'
}

export enum FuelType {
  HIBRID = 'H',
  ELECTRIC = 'E',
  COMBUSTION = 'C'
}
